// Handle Accessibly Widget slide animation
(function () {
  'use strict';

  let isAnimating = false;
  let widgetObserver = null;

  // Watch for widget display changes to add opening/closing animation
  function watchWidgetDisplay() {
    const widget = document.getElementById('accessiblyAppDialog');
    if (!widget) return;

    // Disconnect previous observer if exists
    if (widgetObserver) {
      widgetObserver.disconnect();
    }

    let previousDisplay = window.getComputedStyle(widget).display;

    widgetObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const currentDisplay = window.getComputedStyle(widget).display;

          // Widget is becoming visible (opening)
          if (previousDisplay === 'none' && currentDisplay !== 'none' && !isAnimating) {
            isAnimating = true;
            widget.classList.add('accessibly-app-opening');
            setTimeout(() => {
              widget.classList.remove('accessibly-app-opening');
              isAnimating = false;
            }, 400);
            previousDisplay = currentDisplay;
          }
          // Widget is being hidden (closing)
          else if (previousDisplay !== 'none' && currentDisplay === 'none' && !isAnimating) {
            isAnimating = true;

            // Disconnect observer temporarily to prevent infinite loop
            widgetObserver.disconnect();

            // Restore display temporarily to show closing animation
            widget.style.display = previousDisplay;
            widget.classList.add('accessibly-app-closing');

            setTimeout(() => {
              widget.style.display = 'none';
              widget.classList.remove('accessibly-app-closing');
              isAnimating = false;
              previousDisplay = 'none';

              // Reconnect observer
              widgetObserver.observe(widget, {
                attributes: true,
                attributeFilter: ['style']
              });
            }, 400);
          }
          else {
            previousDisplay = currentDisplay;
          }
        }
      });
    });

    widgetObserver.observe(widget, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  // Initialize when DOM is ready
  function init() {
    watchWidgetDisplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when widget is added to DOM (in case it's dynamically loaded)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.id === 'accessiblyAppDialog' || (node.querySelector && node.querySelector('#accessiblyAppDialog'))) {
          init();
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
